import type { BlockExportMapping } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { Root } from "@/react/components/shared/BuilderUI/DefaultBlocks/Root";

import { FormButtonBlock } from "./FormButtonBlock";
import { blockToElement as FormButtonBlockToElement } from "./FormButtonBlock/blockToElement";
import { elementToBlock as FormButtonElementToBlock } from "./FormButtonBlock/elementToBlock";
import { FormContactEmailBlock } from "./FormContactEmailBlock";
import { blockToElement as FormContactEmailBlockToElement } from "./FormContactEmailBlock/blockToElement";
import { elementToBlock as FormContactEmailElementToBlock } from "./FormContactEmailBlock/elementToBlock";
import { FormContactNameBlock } from "./FormContactNameBlock";
import { blockToElement as FormContactNameBlockToElement } from "./FormContactNameBlock/blockToElement";
import { elementToBlock as FormContactNameElementToBlock } from "./FormContactNameBlock/elementToBlock";
import { FormDropdownBlock } from "./FormDropdownBlock";
import { blockToElement as FormDropdownBlockToElement } from "./FormDropdownBlock/blockToElement";
import { elementToBlock as FormDropdownElementToBlock } from "./FormDropdownBlock/elementToBlock";
import { FormEmailBlock } from "./FormEmailBlock";
import { blockToElement as FormEmailBlockToElement } from "./FormEmailBlock/blockToElement";
import { elementToBlock as FormEmailElementToBlock } from "./FormEmailBlock/elementToBlock";
import { FormHeadingBlock } from "./FormHeadingBlock";
import { blockToElement as FormHeadingBlockToElement } from "./FormHeadingBlock/blockToElement";
import { elementToBlock as FormHeadingElementToBlock } from "./FormHeadingBlock/elementToBlock";
import { FormLinkBlock } from "./FormLinkBlock";
import { blockToElement as FormLinkBlockToElement } from "./FormLinkBlock/blockToElement";
import { elementToBlock as FormLinkElementToBlock } from "./FormLinkBlock/elementToBlock";
import { FormLongAnswerBlock } from "./FormLongAnswerBlock";
import { blockToElement as FormLongAnswerBlockToElement } from "./FormLongAnswerBlock/blockToElement";
import { elementToBlock as FormLongAnswerElementToBlock } from "./FormLongAnswerBlock/elementToBlock";
import { FormMultipleChoiceBlock } from "./FormMultipleChoiceBlock";
import { blockToElement as FormMultipleChoiceBlockToElement } from "./FormMultipleChoiceBlock/blockToElement";
import { elementToBlock as FormMultipleChoiceElementToBlock } from "./FormMultipleChoiceBlock/elementToBlock";
import { FormNumberBlock } from "./FormNumberBlock";
import { blockToElement as FormNumberBlockToElement } from "./FormNumberBlock/blockToElement";
import { elementToBlock as FormNumberElementToBlock } from "./FormNumberBlock/elementToBlock";
import { FormParagraphBlock } from "./FormParagraphBlock";
import { blockToElement as FormParagraphBlockToElement } from "./FormParagraphBlock/blockToElement";
import { elementToBlock as FormParagraphElementToBlock } from "./FormParagraphBlock/elementToBlock";
import { FormShortAnswerBlock } from "./FormShortAnswerBlock";
import { blockToElement as FormShortAnswerBlockToElement } from "./FormShortAnswerBlock/blockToElement";
import { elementToBlock as FormShortAnswerElementToBlock } from "./FormShortAnswerBlock/elementToBlock";
import { FormSingleChoiceBlock } from "./FormSingleChoiceBlock";
import { blockToElement as FormSingleChoiceBlockToElement } from "./FormSingleChoiceBlock/blockToElement";
import { elementToBlock as FormSingleChoiceElementToBlock } from "./FormSingleChoiceBlock/elementToBlock";
import { FormStackBlock } from "./FormStackBlock";
import { blockToElement as FormStackBlockToElement } from "./FormStackBlock/blockToElement";
import { elementToBlock as FormStackElementToBlock } from "./FormStackBlock/elementToBlock";

export const formBlocks: BlockExportMapping = {
  root: Root,
  FormContactEmailBlock,
  FormContactNameBlock,
  FormHeadingBlock,
  FormShortAnswerBlock,
  FormLongAnswerBlock,
  FormLinkBlock,
  FormSingleChoiceBlock,
  FormMultipleChoiceBlock,
  FormDropdownBlock,
  FormNumberBlock,
  FormEmailBlock,
  FormParagraphBlock,
  FormButtonBlock,
  FormStackBlock,
};

// Registry of block conversion functions
export const blockConverters = {
  FormContactNameBlock: {
    elementToBlock: FormContactNameElementToBlock,
    blockToElement: FormContactNameBlockToElement,
  },
  FormContactEmailBlock: {
    elementToBlock: FormContactEmailElementToBlock,
    blockToElement: FormContactEmailBlockToElement,
  },
  FormHeadingBlock: {
    elementToBlock: FormHeadingElementToBlock,
    blockToElement: FormHeadingBlockToElement,
  },
  FormLongAnswerBlock: {
    elementToBlock: FormLongAnswerElementToBlock,
    blockToElement: FormLongAnswerBlockToElement,
  },
  FormLinkBlock: {
    elementToBlock: FormLinkElementToBlock,
    blockToElement: FormLinkBlockToElement,
  },
  FormParagraphBlock: {
    elementToBlock: FormParagraphElementToBlock,
    blockToElement: FormParagraphBlockToElement,
  },
  FormShortAnswerBlock: {
    elementToBlock: FormShortAnswerElementToBlock,
    blockToElement: FormShortAnswerBlockToElement,
  },
  FormSingleChoiceBlock: {
    elementToBlock: FormSingleChoiceElementToBlock,
    blockToElement: FormSingleChoiceBlockToElement,
  },
  FormMultipleChoiceBlock: {
    elementToBlock: FormMultipleChoiceElementToBlock,
    blockToElement: FormMultipleChoiceBlockToElement,
  },
  FormDropdownBlock: {
    elementToBlock: FormDropdownElementToBlock,
    blockToElement: FormDropdownBlockToElement,
  },
  FormNumberBlock: {
    elementToBlock: FormNumberElementToBlock,
    blockToElement: FormNumberBlockToElement,
  },
  FormEmailBlock: {
    elementToBlock: FormEmailElementToBlock,
    blockToElement: FormEmailBlockToElement,
  },
  FormButtonBlock: {
    elementToBlock: FormButtonElementToBlock,
    blockToElement: FormButtonBlockToElement,
  },
  FormStackBlock: {
    elementToBlock: FormStackElementToBlock,
    blockToElement: FormStackBlockToElement,
  },
};
